import { ICreator } from '~/types/creator';

export const creator: ICreator = {
  id: 'brielle-carter-123',
  slug: 'brielle-carter',
  email: 'brielle@example.com',
  firstName: 'Brielle',
  lastName: 'Carter',
  fullName: 'Brielle Carter',
  name: 'Brielle Carter',
  avatar: '/images/brielle-carter.png',
  profilePicUrl: '/images/brielle-carter.png',
  biography:
    "I'm Brielle Carter, a food and lifestyle creator redefining comfort content. I love creating vibrant new recipes. experimenting with my style, and engaging with my loyal audience across Instagram and TikTok. Rooted in community and joy, I inspire others to cook more, live slower and savor every bite.",
  bioAgency:
    "I'm Brielle Carter, a food and lifestyle creator redefining comfort content. I love creating vibrant new recipes. experimenting with my style, and engaging with my loyal audience across Instagram and TikTok. Rooted in community and joy, I inspire others to cook more, live slower and savor every bite.",
  category: 'Fashion & Lifestyle',
  categoryAgency: 'Lifestyle, Wellness, Food',
  city: 'San Francisco',
  age: 26,
  location: {
    city: 'San Francisco',
    country: 'United States',
    countryCode: 'US',
    countryCodeAlpha3: 'United States',
    districtName: 'San Francisco County',
    fullAddress: 'San Francisco, CA, United States',
    geo: {
      lat: 37.7749,
      lon: -122.4194,
    },
    id: 'san-francisco-ca-us',
    mapboxId: 'place.789012',
    placeFormatted: 'San Francisco, CA, United States',
    postCode: '94102',
    regionCode: 'CA',
    regionName: 'California',
    type: 'place',
  },
  genderAgency: 'Female',
  totalAudience: 2500000,
  echoWelcomeSeen: true,
  belongsToSameAgency: false,
  isPubliclyVisible: true,
  isOnCampaign: false,
  isOffPlatform: false,
  hasConnectedPlatform: true,
  platformFullAccess: true,
  isCoManager: false,
  isManagerOwner: false,
  benchmark: { id: 'benchmark-123' },
  echoWebStatus: 1,
  status: 'connected',
  platforms: {
    instagram: {
      handle: '@briellecarter',
      name: 'Brielle Carter',
      avatar: '/images/brielle-carter.png',
      followersCount: 674400,
      isConnected: true,
      isTokenValid: true,
      shouldReAuth: false,
      reminderSentCount: 0,
      status: 'connected',
      firstAuthAt: new Date('2023-01-15T10:30:00Z'),
    },
    tiktok: {
      handle: '@briellecarter',
      name: 'Brielle Carter',
      avatar: '/images/brielle-carter.png',
      followersCount: 2800000,
      isConnected: true,
      isTokenValid: true,
      shouldReAuth: false,
      reminderSentCount: 0,
      status: 'connected',
      firstAuthAt: new Date('2023-02-01T09:15:00Z'),
    },
  },
  webLinks: ['https://linkedin.com/in/brielle-carter'],
  createdAt: '2023-01-01T00:00:00Z',
  updatedAt: '2024-01-15T14:30:00Z',
};

export const editorState = {
  editorState: {
    root: {
      children: [
        {
          children: [
            {
              detail: 0,
              format: 0,
              mode: 'normal',
              style: '',
              text: 'My audience is a loyal community of food lovers and cozy living enthusiasts. Our shared passion for honest flavor and genuine connection makes them an ideal audience for brands that value authenticity.',
              type: 'text',
              version: 1,
            },
          ],
          direction: 'ltr',
          format: '',
          indent: 0,
          type: 'paragraph',
          version: 1,
        },
        {
          children: [
            { type: 'linebreak', version: 1 },
            {
              detail: 0,
              format: 0,
              mode: 'normal',
              style: '',
              text: 'With a focus on heartfelt storytelling and genuine engagement, my content consistently delivers exceptional reach. Explore my key performance metrics to see the impact of my unique voice.',
              type: 'text',
              version: 1,
            },
          ],
          direction: 'ltr',
          format: '',
          indent: 0,
          type: 'paragraph',
          version: 1,
        },
      ],
      direction: 'ltr',
      format: '',
      indent: 0,
      type: 'root',
      version: 1,
    },
  },
};

export const talentCharts = {
  platform: 'instagram',
  creatorId: 'brielle-carter-charts',
  demographics: ['gender', 'age', 'country'],
  metrics: [
    'Average Reach',
    'Average Views',
    'Average Engagements',
    'Follower Engagement Rate',
    'Reach Engagement Rate',
    'View Engagement Rate',
  ],
};

export const demographicsData = {
  genders: {
    male: 50,
    female: 50,
    other: 0,
  },
  ages: [
    {
      age: '13-17',
      count: 2,
    },
    {
      age: '18-24',
      count: 35,
    },
    {
      age: '25-34',
      count: 55,
    },
    {
      age: '35-44',
      count: 20,
    },
    {
      age: '45-64',
      count: 5,
    },
    {
      age: '65+',
      count: 0,
    },
  ],
  countries: [
    {
      country: 'United States of America',
      value: 76,
    },
    {
      country: 'Mexico',
      value: 22,
    },
    {
      country: 'Canada',
      value: 2,
    },
  ],
};

export const metricsData = [
  {
    title: 'Average Reach',
    subtitle: 'Last 30 days - Reels, Stories, Posts',
    value: 22125,
    transformValue: 'number',
  },
  {
    title: 'Average Views',
    subtitle: 'Last 30 days - Stories, Posts',
    value: 22450,
    transformValue: 'number',
  },
  {
    title: 'Average Engagements',
    subtitle: 'Last 30 days - Reels, Posts',
    value: 4600,
    transformValue: 'number',
  },
  {
    title: 'Follower Engagement Rate',
    subtitle: 'Last 30 days - Reels, Posts',
    value: 0.12,
    transformValue: 'percentage',
  },
  {
    title: 'Reach Engagement Rate',
    subtitle: 'Last 30 days - Reels, Posts',
    value: 0.211,
    transformValue: 'percentage',
  },
  {
    title: 'View Engagement Rate',
    subtitle: 'Last 30 days - Posts',
    value: 0.039,
    transformValue: 'percentage',
  },
];

export const brandLogos = [
  {
    id: 'whole-foods-market',
    url: '/images/whole-foods.png',
    brandName: 'Whole Foods Market',
  },
  {
    id: 'oatly',
    url: '/images/oatly.png',
    brandName: 'Oatly',
  },
  {
    id: 'starbucks',
    url: '/images/starbucks.png',
    brandName: 'Starbucks',
  },
  {
    id: 'breville',
    url: '/images/breville.jpg',
    brandName: 'Breville',
  },
];

export const featuredContent = [
  {
    assets: [
      {
        name: 'default',
        url: '/images/content_1.png',
        width: 120,
        height: 90,
      },
      {
        name: 'high',
        url: '/images/content_1.png',
        width: 480,
        height: 360,
      },
      {
        name: 'medium',
        url: '/images/content_1.png',
        width: 320,
        height: 180,
      },
      {
        name: 'standard',
        url: '/images/content_1.png',
        width: 640,
        height: 480,
      },
      {
        name: 'maxres',
        url: '/images/content_1.png',
        width: 1280,
        height: 720,
      },
    ],
    creator: {
      avatar: '/images/brielle-carter.png',
      fullName: 'Brielle Carter',
      id: 'brielle-carter-123',
      slug: 'brielle-carter',
      status: 'off-platform',
    },
    id: '1d24d96d-83e7-452b-8eec-9aa3c89a6dc7',
    platform: 'youtube',
    content_type: 'VIDEO',
    status: 'on-platform',
    thumbnails: {
      default: {
        url: '/images/content_1.png',
        name: 'default',
        thumbnail: null,
        type: 'IMAGE',
        width: 120,
        height: 90,
      },
      high: {
        url: '/images/content_1.png',
        name: 'high',
        thumbnail: null,
        type: 'IMAGE',
        width: 480,
        height: 360,
      },
      medium: {
        url: '/images/content_1.png',
        name: 'medium',
        thumbnail: null,
        type: 'IMAGE',
        width: 320,
        height: 180,
      },
      standard: {
        url: '/images/content_1.png',
        name: 'standard',
        thumbnail: null,
        type: 'IMAGE',
        width: 640,
        height: 480,
      },
      maxres: {
        url: '/images/content_1.png',
        name: 'maxres',
        thumbnail: null,
        type: 'IMAGE',
        width: 1280,
        height: 720,
      },
    },
    caption: '',
    comments: 6028,
    contentId: '1d24d96d-83e7-452b-8eec-9aa3c89a6dc7',
    createdTime: '2024-09-23T07:35:40.000+00:00',
    dislikes: 0,
    favourites: 0,
    likes: 3443709,
    networkId: 'nbzQdlWrcnk',
    shareLink:
      'https://app.dev.usefoam.com/shared/youtube-content/yt-share-8a4416ea66ec5e1d83ab882021630b5f29acf32531ef043accf45e96bd0a556a',
    type: 'video',
    updatedAt: '2024-09-27T03:46:33.000+00:00',
    insightLastUpdatedAt: null,
    views: 187000,
    ytVideoId: 'nbzQdlWrcnk',
    viewCount: 187000,
    likeCount: 3443709,
    commentCount: 6028,
    dislikeCount: 0,
  },
  {
    assets: [
      {
        previewUrl: '/images/content_2.png',
        url: '/images/content_2.png',
        height: 960,
        width: 540,
      },
    ],
    creator: {
      avatar: '/images/brielle-carter.png',
      fullName: 'Brielle Carter',
      id: 'brielle-carter-123',
      slug: 'brielle-carter',
      status: 'off-platform',
    },
    id: 'c8d35127-e33f-4f6b-87c3-9a4d3785bd20',
    platform: 'tiktok',
    content_type: 'VIDEO',
    status: 'off-platform',
    caption:
      'We are so close! Donate now to #teamwater to help give 2 million people access to clean water!',
    comments: 7822,
    contentId: 'c8d35127-e33f-4f6b-87c3-9a4d3785bd20',
    embedUrl: 'https://www.tiktok.com/player/v1/7540143785636826398',
    engagementRate: 0.0040607134393413,
    engagements: 190000,
    externalUrl: 'https://www.tiktok.com/@mrbeast/video/7540143785636826398',
    followerEngagementRate: 0.000007838133334110422,
    likes: 81883,
    publishedAt: '2025-08-19T04:09:20.000+00:00',
    shareLink:
      'https://app.dev.usefoam.com/shared/tiktok-content/tik-tok-content-share-a20a7ab85a97cbb765c8dc5bc223e4a6e0be29a1396074a93c6e112c3519faa8',
    shares: 3629,
    type: 'video',
    updatedAt: '2025-09-17T17:16:27.000+00:00',
    insightLastUpdatedAt: null,
    views: 227000,
    reach: 190000,
    createTime: '2025-08-19T04:09:20.000+00:00',
    engagementCount: 190000,
    videoViews: 227000,
  },
  {
    assets: [
      {
        height: 1920,
        previewUrl: '/images/content_3.png',
        type: 'image',
        url: '/images/content_3.png',
        width: 1440,
      },
      {
        height: 1920,
        previewUrl: '/images/content_3.png',
        type: 'image',
        url: '/images/content_3.png',
        width: 1440,
      },
      {
        height: 1920,
        previewUrl: '/images/content_3.png',
        type: 'image',
        url: '/images/content_3.png',
        width: 1440,
      },
      {
        height: 1920,
        previewUrl: '/images/content_3.png',
        type: 'image',
        url: '/images/content_3.png',
        width: 1440,
      },
      {
        height: 1920,
        previewUrl: '/images/content_3.png',
        type: 'image',
        url: '/images/content_3.png',
        width: 1440,
      },
      {
        height: 1920,
        previewUrl: '/images/content_3.png',
        type: 'image',
        url: '/images/content_3.png',
        width: 1440,
      },
    ],
    creator: {
      avatar: '/images/brielle-carter.png',
      fullName: 'Brielle Carter',
      id: 'brielle-carter-123',
      slug: 'brielle-carter',
      status: 'on-platform',
    },
    id: '52851129-10c3-4ab6-a8ba-b7062dd72aba',
    platform: 'instagram',
    content_type: 'CAROUSEL_ALBUM',
    status: 'on-platform',
    caption: 'The VMAs were fun :)',
    channel: 'post',
    comments: null,
    viewsCount: 87000,
    reach: 65000,
    engagements: 125000,
    contentId: '52851129-10c3-4ab6-a8ba-b7062dd72aba',
    likes: null,
    publishedAt: '2025-09-09T01:14:28.000+00:00',
    shareUrl: 'https://www.instagram.com/p/DOXNeLzjAR3/',
    type: 'image',
    updatedAt: '2025-09-23T22:28:54.531+00:00',
    insightLastUpdatedAt: '2025-09-23T22:28:54.531+00:00',
    postedAt: '2025-09-09T01:14:28.000+00:00',
    productType: 'FEED',
    contentType: 'CAROUSEL_ALBUM',
  },
];
